import { render, staticRenderFns } from "./CrearCategoriaView.vue?vue&type=template&id=6cae033f&"
import script from "./CrearCategoriaView.vue?vue&type=script&lang=js&"
export * from "./CrearCategoriaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports